/**
 * Date-extensions locale Latvian [lv]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('lv', {
    monthNames: ['Janvāris','Februāris','Marts','Aprīlis','Maijs','Jūnijs','Jūlijs','Augusts','Septembris','Oktobris','Novembris','Decembris'],
    monthShortNames: ['Jan','Feb','Mar','Apr','Mai','Jūn','Jūl','Aug','Sep','Okt','Nov','Dec'],
    dayNames: ['Svētdiena','Pirmdiena','Otrdiena','Trešdiena','Ceturtdiena','Piektdiena','Sestdiena'],
    dayShortNames: ['Sv','P','O','T','C','Pk','S']
});
